<template>
  <v-container fluid id="my-daily-reports" class="pa-0 pa-sm-3">
    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        Daily Reports
      </v-col>
      <v-col cols="12" lg="8" class="">
        <my-job-sites />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import myJobSites from "@/components/MyJobSites";
export default {
  components: {
    myJobSites: myJobSites,
  },
  data() {
    return {
      jobs: [],
    };
  },
  computed: {
    ...mapState(["user", "jobSites"]),
  },
  async created() {},
  methods: {
    today() {
      return moment().format("YYYY-MM-DD");
    },
    goTo(jobSiteId) {
      this.$router.push(`/daily-reports/${jobSiteId}/${this.today()}`);
    },
  },
};
</script>
